<template>
  <zm-button
    size='large'
    plain
    round
    icon='zm-icon-download-alt-thin'
    class='opc-succezz_download-action'
    @click='handleDownload'>
    {{ $t('billing.success.confirmation.download_zoom') }}
  </zm-button>
</template>
<script>
export default {
  props: {
    downloadUrl: {
      type: String,
      default: "https://zoom.us/support/download"
    }
  },
  methods: {
    handleDownload() {
      this.$tracking.buyInteraction('purchase confirmation', 'download zoom');
      window.open(this.downloadUrl, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.opc-succezz_download-action {
  &.zm-button--plain:not(.is-ghost) {
    border: 1px solid #0C5CFF;
    padding-bottom: 7px;
    padding-top: 7px;
  }

  /deep/ i {
    color: #0C5CFF;
  }

  /deep/.zm-button__slot {
    color: #0C5CFF;
  }
}
</style>
